import React from "react";
import { CtaButtons } from "./CtaButtons";
export function FinalCta() {
  return <section id="unirme" className="px-6 py-24 text-center sm:py-32" data-id="element-34" data-mp="vffvgpvh26si">
      <div className="mx-auto max-w-2xl" data-id="element-35" data-mp="vhajid21if0t">
        <p className="mb-4 text-sm font-semibold text-gold" data-id="element-36" data-mp="19f7g39ghulfh">Sumate ahora</p>
        <h2 className="mb-4 font-serif text-[clamp(32px,5vw,52px)] font-bold leading-tight" data-id="element-37" data-mp="15ddkhfl5o7m6">
          Tu primer ebook puede empezar hoy
        </h2>
        <p className="mb-8 text-base leading-relaxed text-muted" data-id="element-38" data-mp="1jbtwnm1seqbp">
          Comunidad activa, asesoría semanal y el sistema completo para vender en Argentina y al mundo.
        </p>
        <p className="mb-10 text-[15px] text-soft" data-id="element-39" data-mp="1t1wovk13408z">
          <span className="font-serif text-3xl font-black text-white" data-id="element-40" data-mp="1t4r9bbk3ll2e">$27</span>{" "}
          <span className="text-muted" data-id="element-41" data-mp="1o5y6qe6cneh0">USD por mes</span>
          <span className="mx-3 text-ink-4" aria-hidden="true" data-id="element-42" data-mp="224o4lw0zti6f">|</span>
          <span className="font-serif text-3xl font-black text-white" data-id="element-43" data-mp="1x4tcxq9e8okb">$40.000</span>{" "}
          <span className="text-muted" data-id="element-44" data-mp="n5m6o3b5462e">ARS por mes</span>
          <span className="mt-2 block text-sm text-muted" data-id="element-45" data-mp="n75mxtwsqh46">Cancelás cuando querés</span>
        </p>
        <CtaButtons data-id="element-46" data-mp="s5h0aemav9r5" />
      </div>
    </section>;
}